import { useState } from "react";

/* ─── Logos partenaires — version hero (blanc) et normal (couleur) ─── */
const PARTNERS = [
  {
    name: "Airbnb",
    renderHero: () => (
      <span style={{ fontFamily: "var(--font-sans)", fontWeight: 700, fontSize: "1.1rem", color: "#fff", letterSpacing: "-0.02em" }}>
        Airbnb
      </span>
    ),
    renderDefault: () => (
      <span style={{ fontFamily: "var(--font-sans)", fontWeight: 700, fontSize: "1.1rem", color: "#FF5A5F", letterSpacing: "-0.02em" }}>
        Airbnb
      </span>
    ),
  },
  {
    name: "Booking.com",
    renderHero: () => (
      <span style={{ fontFamily: "var(--font-sans)", fontWeight: 800, fontSize: "1.1rem", color: "#fff", letterSpacing: "-0.02em" }}>
        Booking.com
      </span>
    ),
    renderDefault: () => (
      <span style={{ fontFamily: "var(--font-sans)", fontWeight: 800, fontSize: "1.1rem", color: "#003580", letterSpacing: "-0.02em" }}>
        Booking.com
      </span>
    ),
  },
  {
    name: "Abritel",
    renderHero: () => (
      <span style={{ fontFamily: "var(--font-sans)", fontWeight: 700, fontSize: "1.1rem", color: "#fff", letterSpacing: "-0.01em" }}>
        Abritel
      </span>
    ),
    renderDefault: () => (
      <span style={{ fontFamily: "var(--font-sans)", fontWeight: 700, fontSize: "1.1rem", color: "#3246a8", letterSpacing: "-0.01em" }}>
        Abritel
      </span>
    ),
  },
  {
    name: "Leboncoin",
    renderHero: () => (
      <span style={{ fontFamily: "var(--font-sans)", fontWeight: 800, fontSize: "1.1rem", color: "#fff", letterSpacing: "-0.02em" }}>
        Leboncoin
      </span>
    ),
    renderDefault: () => (
      <span style={{ fontFamily: "var(--font-sans)", fontWeight: 800, fontSize: "1.1rem", color: "#F56B2A", letterSpacing: "-0.02em" }}>
        Leboncoin
      </span>
    ),
  },
];

/* ─── Composant Marquee ─── */
export default function PartnersMarquee({ variant = "default" }) {
  const [isPaused, setIsPaused] = useState(false);
  const isHero = variant === "hero";

  const tripled = [...PARTNERS, ...PARTNERS, ...PARTNERS];

  return (
    <div className={`overflow-hidden ${isHero ? "py-3 sm:py-4 bg-black/30 backdrop-blur-md border-t border-white/10" : "py-5 sm:py-7 bg-white border-b border-[#f1eee6]"}`}>
      {/* Label */}
      <p
        className={`text-center text-[10px] sm:text-[11px] font-medium tracking-[0.18em] uppercase mb-3 sm:mb-4 ${isHero ? "text-white/40" : "text-[#c0b99f]"}`}
        style={{ fontFamily: "var(--font-sans)" }}
      >
        Plateformes partenaires
      </p>

      {/* Marquee container */}
      <div
        className="relative"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        {/* Fade edges */}
        <div className={`absolute left-0 top-0 bottom-0 w-16 sm:w-24 z-10 pointer-events-none ${isHero ? "bg-gradient-to-r from-black/40 to-transparent" : "bg-gradient-to-r from-white to-transparent"}`} />
        <div className={`absolute right-0 top-0 bottom-0 w-16 sm:w-24 z-10 pointer-events-none ${isHero ? "bg-gradient-to-l from-black/40 to-transparent" : "bg-gradient-to-l from-white to-transparent"}`} />

        {/* Scrolling track */}
        <div
          className="flex items-center"
          style={{
            animation: "partners-marquee 35s linear infinite",
            animationPlayState: isPaused ? "paused" : "running",
            width: "max-content",
          }}
        >
          {tripled.map((partner, i) => (
            <div
              key={`${partner.name}-${i}`}
              className={`flex-shrink-0 flex items-center justify-center px-6 sm:px-10 md:px-12 transition-all duration-500 ${isHero ? "opacity-60 hover:opacity-100" : "opacity-80 hover:opacity-100"}`}
            >
              {isHero ? partner.renderHero() : partner.renderDefault()}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes partners-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.333%); }
        }
      `}</style>
    </div>
  );
}
